<template>
    <div class="text-center text-muted text-sm" v-if="this.ordersNewAmount > 0">
        <vs-alert active="true" class="text-center" v-if="this.ordersNewAmount === 1">
            Er is {{this.ordersNewAmount}} nieuwe bestelling.
            <reload-button/>
        </vs-alert>
        <vs-alert active="true" class="text-center" v-else>
            Er zijn {{this.ordersNewAmount}} nieuwe bestellingen.
            <reload-button/>
        </vs-alert>
    </div>
</template>

<script>
import ReloadButton from './reload-button';
export default {
	components: {ReloadButton},
	props: {
		ordersNewAmount: {
			required: true,
		}
	}
}
</script>
